import { Col, Row, Spinner2, Text } from 'components';
import { theme } from 'lib';
import React from 'react';

/**
 * Life-to-date participation totals shown above a poll / quiz list.
 *
 * Purely presentational — the caller fetches `/admin/polls/summary` or
 * `/admin/quizzes/summary` with the same filters it used for the list, so the strip always
 * describes exactly the rows rendered beneath it.
 *
 * `items` is an array of { label, value, hint? }. Values are pre-formatted by the caller.
 */

const Metric = ({ label, value, hint, loading }) => (
  <Col noFlex style={{ minWidth: 110 }}>
    {loading ? (
      // Sized and aligned to occupy the same box as the value it stands in for, so the
      // labels beneath don't shift when the numbers land.
      <Row start noFlex ht="24px" style={{ alignItems: 'center' }}>
        <Spinner2 spinnerSize="18px" style={{ margin: 0 }} />
      </Row>
    ) : (
      <Text h4 style={{ lineHeight: 1.2 }}>
        {value}
      </Text>
    )}
    <Text c2 col={theme.GREY_60} marg="2px 0 0">
      {label}
    </Text>
    {hint && !loading && (
      <Text c2 col={theme.GREY_40} marg="1px 0 0">
        {hint}
      </Text>
    )}
  </Col>
);

const ParticipationSummary = ({ items, loading, note }) => {
  if (!items?.length) return null;

  return (
    <Col
      noFlex
      wid="100%"
      marg="16px 0 12px"
      pad="14px 18px"
      style={{ background: theme.GREY_10, borderRadius: 10 }}
    >
      <Row start wrap gap="28px" style={{ width: '100%' }}>
        {items.map((item) => (
          <Metric
            key={item.label}
            label={item.label}
            value={item.value}
            hint={item.hint}
            loading={loading}
          />
        ))}
      </Row>
      {note && (
        <Text c2 col={theme.GREY_40} marg="10px 0 0">
          {note}
        </Text>
      )}
    </Col>
  );
};

export default ParticipationSummary;
